// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

export const encodeURL = (v) => encodeURIComponent(v).replace(/\//g, "::");
export const decodeURL = (v) => decodeURIComponent(v).replace(/::/g, "/");